function backIn(t) {
  var s = 1.70158
  return t * t * ((s + 1) * t - s)
}

module.exports = backIn


//////////////////
// WEBPACK FOOTER
// ../node_modules/eases/back-in.js
// module id = 89
// module chunks = 0